import React from "react";
import footerbgnew from "../assets/images/footerbgnew.jpg";
import footermobile from "../assets/images/footermobile.webp";
import voyageheader from "../assets/images/voyageheader.webp";
import IATAlogo from "../assets/images/IATAlogo.webp";

const Footer = () => {
  return (
    <footer className="relative overflow-hidden text-white  bg-[#004fa5]">
      {/* =========================================================
          DESKTOP BACKGROUND
      ========================================================== */}
      <div
        className="absolute inset-0 hidden bg-cover bg-bottom bg-no-repeat lg:block"
        style={{
          backgroundImage: `url(${footerbgnew})`,
        }}
      />

      {/* =========================================================
          MOBILE BACKGROUND
      ========================================================== */}
      <div
        className="absolute inset-0 block bg-cover bg-bottom bg-no-repeat lg:hidden"
        style={{
          backgroundImage: `url(${footermobile})`,
        }}
      />

      <div className="relative z-10">
        {/* =========================================================
            DESKTOP FOOTER
        ========================================================== */}
        <div className="mx-auto hidden max-w-7xl lg:block">
          {/* =======================================================
              MAIN CONTENT
          ======================================================== */}
          <div className="grid grid-cols-[1.45fr_0.8fr_1.15fr_1.25fr] pt-20 pb-12">
            {/* =====================================================
                BRAND
            ====================================================== */}
            <div className=" pr-[40px]">
              <div className="mb-5 flex items-center gap-4">
                <img
                  src={voyageheader}
                  alt="Voyage Plus Travel"
                  className="w-[205px] object-contain object-left md:-mt-8"
                />

                <div className="h-10 w-px shrink-0 bg-white/40 md:-mt-4" />

                <img
                  src={IATAlogo}
                  alt="Second Logo"
                  className="w-[70px] shrink-0 object-contain md:-mt-5"
                />
              </div>

              <p className="mt-[12px] max-w-[390px] text-[16px] leading-[1.8] text-white/90">
                Thoughtfully planned journeys.
                <br />
                Seamless flights, memorable stays
                <br />
                and expert visa assistance — all in one place.
              </p>

              {/* SOCIAL ICONS */}
              <div className="mt-[23px] flex items-center gap-[20px]">
                <a
                  href="https://www.facebook.com/profile.php?id=61582409168512" target="_blank"
                  aria-label="Facebook"
                  className="flex h-[40px] w-[40px] items-center justify-center rounded-full border border-white/50 text-white transition-all duration-300 hover:bg-white hover:text-[#007FC0]"
                >
                  <i className="lab la-facebook-f text-[20px]" />
                </a>

                <a
                  href="https://www.instagram.com/voyagehub.world/" target="_blank"
                  aria-label="Instagram"
                  className="flex h-[40px] w-[40px] items-center justify-center rounded-full border border-white/50 text-white transition-all duration-300 hover:bg-white hover:text-[#007FC0]"
                >
                  <i className="lab la-instagram text-[20px]" />
                </a>

                <a
                  href="https://www.linkedin.com/company/voyage-hub/" target="_blank"
                  aria-label="LinkedIn"
                  className="flex h-[40px] w-[40px] items-center justify-center rounded-full border border-white/50 text-white transition-all duration-300 hover:bg-white hover:text-[#007FC0]"
                >
                  <i className="lab la-linkedin-in text-[20px]" />
                </a>
              </div>
            </div>

            {/* =====================================================
                EXPLORE
            ====================================================== */}
            <div className="border-l border-white/10 pl-[38px]">
              <h3 className="relative inline-block text-[20px] font-medium leading-none text-white">
                Explore
                <span className="absolute -bottom-[15px] left-0 h-[4px] w-[36px] bg-[#A8CF45]" />
              </h3>

              <div className="mt-[34px] flex flex-col gap-[9px]">
                <a
                  href="/"
                  className="text-[16px] leading-[1.6] text-white/90 transition hover:text-white"
                >
                  Home
                </a>

                <a
                  href="/about"
                  className="text-[16px] leading-[1.6] text-white/90 transition hover:text-white"
                >
                  About Us
                </a>

                <a
                  href="/services"
                  className="text-[16px] leading-[1.6] text-white/90 transition hover:text-white"
                >
                  Services
                </a>

                <a
                  href="/contact"
                  className="text-[16px] leading-[1.6] text-white/90 transition hover:text-white"
                >
                  Contact Us
                </a>
              </div>
            </div>

            {/* =====================================================
                TRAVEL SERVICES
            ====================================================== */}
            <div className="border-l border-white/10  pl-[42px]">
              <h3 className="relative inline-block text-[20px] font-medium leading-none text-white">
                Travel Services
                <span className="absolute -bottom-[15px] left-0 h-[4px] w-[36px] bg-[#A8CF45]" />
              </h3>

              <div className="mt-[34px] flex flex-col gap-[9px]">
                <a
                  href="/services/#global-visa-assistance"
                  className="text-[16px] leading-[1.6] text-white/90 transition hover:text-white"
                >
                  Global Visa Assistance
                </a>

                <a
                  href="/services/#uae-tourist-visa"
                  className="text-[16px] leading-[1.6] text-white/90 transition hover:text-white"
                >
                  UAE Tourist Visa
                </a>

                <a
                  href="/services/#global-airline-ticketing"
                  className="text-[16px] leading-[1.6] text-white/90 transition hover:text-white"
                >
                  Airline Ticketing
                </a>

                <a
                  href="/services/#worldwide-hotel-accommodation"
                  className="text-[16px] leading-[1.6] text-white/90 transition hover:text-white"
                >
                  Hotel Booking
                </a>

                <a
                  href="/services/#travel-insurance"
                  className="text-[16px] leading-[1.6] text-white/90 transition hover:text-white"
                >
                  Travel Insurance
                </a>
              </div>
            </div>

            {/* =====================================================
                LET'S CONNECT
            ====================================================== */}
            <div className="border-l border-white/10  pl-[40px]">
              <h3 className="relative inline-block text-[20px] font-medium leading-none text-white">
                Let’s Connect
                <span className="absolute -bottom-[15px] left-0 h-[4px] w-[36px] bg-[#A8CF45]" />
              </h3>

              <div className="mt-[30px] flex flex-col gap-[13px]">
                {/* PHONE */}
                <div className="flex items-center gap-[14px]">
                  <div className="flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border border-white/50">
                    <i className="las la-phone text-[19px]" />
                  </div>

                  <span className="text-[16px] text-white/90">04 388 8222</span>
                </div>

                {/* EMAIL */}
                <div className="flex items-center gap-[14px]">
                  <div className="flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border border-white/50">
                    <i className="las la-envelope text-[18px]" />
                  </div>

                  <span className="whitespace-nowrap text-[16px] text-white/90">
                    info@voyageplustravel.com
                  </span>
                </div>

                {/* ADDRESS */}
                <div className="flex items-start gap-[14px]">
                  <div className="flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border border-white/50">
                    <i className="las la-map-marker-alt text-[19px]" />
                  </div>

                  <span className="pt-[2px] text-[16px] leading-[1.55] text-white/90">
                    1606, Blue Bay Tower,
                    <br />
                    Business Bay, Dubai – UAE
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* =======================================================
              DESKTOP COPYRIGHT
          ======================================================== */}
          <div className="flex min-h-[98px] pt-12 items-center justify-between">
            <p className="text-[12px] text-white/75">
              © Voyage Plus. All rights reserved.
            </p>

            <div className="flex items-center text-[12px] text-white/75">
              <a href="/" className="px-4 transition hover:text-white">
                Privacy Policy
              </a>

              <span className="text-white/40">|</span>

              <a href="/" className="px-4 transition hover:text-white">
                Terms &amp; Conditions
              </a>

              <span className="text-white/40">|</span>

              <a href="/" className="pl-4 transition hover:text-white">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>

        {/* =========================================================
            MOBILE FOOTER
        ========================================================== */}
        <div className="block lg:hidden">
          <div className="px-[25px] pt-[38px]">
            <div className="mb-5 flex items-center gap-4">
              <img
                src={voyageheader}
                alt="Voyage Plus Travel"
                className="w-[205px] max-w-full object-contain object-left"
              />
              <div className="h-10 w-px shrink-0 bg-white/40 md:-mt-4" />

              <img
                src={IATAlogo}
                alt="Second Logo"
                className="w-[70px] shrink-0 object-contain md:-mt-5"
              />
            </div>

            {/* =====================================================
                DESCRIPTION
            ====================================================== */}
            <p className="mt-[20px] max-w-[420px] text-[15px] leading-[1.7] text-white/95">
              Thoughtfully planned journeys.
              <br />
              Seamless flights, memorable stays
              <br />
              and expert visa assistance — all in one place.
            </p>

            {/* =====================================================
                SOCIAL ICONS
            ====================================================== */}
            <div className="mt-[20px] flex items-center gap-[14px]">
              <a
                href="https://www.facebook.com/profile.php?id=61582409168512" target="_blank"
                aria-label="Facebook"
                className="flex h-[48px] w-[48px] shrink-0 items-center justify-center rounded-full border border-white/70"
              >
                <i className="lab la-facebook-f text-[21px]" />
              </a>

              <a
                href="https://www.instagram.com/voyagehub.world/" target="_blank"
                aria-label="Instagram"
                className="flex h-[48px] w-[48px] shrink-0 items-center justify-center rounded-full border border-white/70"
              >
                <i className="lab la-instagram text-[21px]" />
              </a>

              <a
                href="https://www.linkedin.com/company/voyage-hub/" target="_blank"
                aria-label="LinkedIn"
                className="flex h-[48px] w-[48px] shrink-0 items-center justify-center rounded-full border border-white/70"
              >
                <i className="lab la-linkedin-in text-[21px]" />
              </a>
            </div>

            {/* =====================================================
                DIVIDER
            ====================================================== */}
            <div className="mt-[30px] border-t border-white/30" />

            {/* =====================================================
                EXPLORE + TRAVEL SERVICES
            ====================================================== */}
            <div className="grid grid-cols-[0.85fr_1.15fr] gap-[20px] py-[30px]">
              {/* EXPLORE */}
              <div className="min-w-0">
                <h3 className="relative inline-block text-[20px] font-semibold leading-none text-white">
                  Explore
                  <span className="absolute -bottom-[13px] left-0 h-[4px] w-[42px] bg-[#A8CF45]" />
                </h3>

                <div className="mt-[29px] flex flex-col gap-[7px]">
                  <a
                    href="/"
                    className="text-[15px] leading-[1.65] text-white/95"
                  >
                    Home
                  </a>

                  <a
                    href="/about"
                    className="text-[15px] leading-[1.65] text-white/95"
                  >
                    About Us
                  </a>

                  <a
                    href="/services"
                    className="text-[15px] leading-[1.65] text-white/95"
                  >
                    Services
                  </a>

                  <a
                    href="/contact"
                    className="text-[15px] leading-[1.65] text-white/95"
                  >
                    Contact Us
                  </a>
                </div>
              </div>

              {/* TRAVEL SERVICES */}
              <div className="min-w-0">
                <h3 className="relative inline-block text-[20px] font-semibold leading-none text-white">
                  Travel Services
                  <span className="absolute -bottom-[13px] left-0 h-[4px] w-[42px] bg-[#A8CF45]" />
                </h3>

                <div className="mt-[29px] flex flex-col gap-[7px]">
                  <a
                    href="/services/#global-visa-assistance"
                    className="text-[15px] leading-[1.65] text-white/95"
                  >
                    Global Visa Assistance
                  </a>

                  <a
                    href="/services/#uae-tourist-visa"
                    className="text-[15px] leading-[1.65] text-white/95"
                  >
                    UAE Tourist Visa
                  </a>

                  <a
                    href="/services/#global-airline-ticketing"
                    className="text-[15px] leading-[1.65] text-white/95"
                  >
                    Airline Ticketing
                  </a>

                  <a
                    href="/services/#worldwide-hotel-accommodation"
                    className="text-[15px] leading-[1.65] text-white/95"
                  >
                    Hotel Booking
                  </a>

                  <a
                    href="/services/#travel-insurance"
                    className="text-[15px] leading-[1.65] text-white/95"
                  >
                    Travel Insurance
                  </a>
                </div>
              </div>
            </div>

            {/* =====================================================
                DIVIDER
            ====================================================== */}
            <div className="border-t border-white/30" />

            {/* =====================================================
                LET'S CONNECT
            ====================================================== */}
            <div className="pt-[30px]">
              <h3 className="relative inline-block text-[20px] font-semibold leading-none text-white">
                Let’s Connect
                <span className="absolute -bottom-[13px] left-0 h-[4px] w-[48px] bg-[#A8CF45]" />
              </h3>

              <div className="mt-[30px] flex flex-col gap-[12px]">
                {/* PHONE */}
                <div className="flex items-center gap-[15px]">
                  <div className="flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border border-white/70">
                    <i className="las la-phone text-[22px]" />
                  </div>

                  <span className="text-[15px] text-white/95">04 388 8222</span>
                </div>

                {/* EMAIL */}
                <div className="flex items-center gap-[15px]">
                  <div className="flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border border-white/70">
                    <i className="las la-envelope text-[21px]" />
                  </div>

                  <span className="break-all text-[15px] leading-6 text-white/95">
                    info@voyageplustravel.com
                  </span>
                </div>

                {/* ADDRESS */}
                <div className="flex items-start gap-[15px]">
                  <div className="flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full border border-white/70">
                    <i className="las la-map-marker-alt text-[22px]" />
                  </div>

                  <span className="pt-[3px] text-[15px] leading-[1.55] text-white/95">
                    1606, Blue Bay Tower,
                    <br />
                    Business Bay, Dubai – UAE
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* =====================================================
              MOBILE COPYRIGHT
          ====================================================== */}
          <div className="mt-[85px] border-t border-white/25 px-[20px] py-[20px]">
            <p className="text-center text-[13px] text-white/90">
              © Voyage Plus. All rights reserved.
            </p>

            <div className="mt-[10px] flex flex-wrap items-center justify-center text-[12px] leading-6 text-white/85">
              <a href="/" className="px-[7px]">
                Privacy Policy
              </a>

              <span>|</span>

              <a href="/" className="px-[7px]">
                Terms &amp; Conditions
              </a>

              <span>|</span>

              <a href="/" className="px-[7px]">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
